<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Institute Settings</h5>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <a-spin :spinning="loading">
          <a-form class="mb-4" :form="form">
            <p>Basic Details</p>
            <div class="row">
              <div class="col-md-8">
                <a-form-item label="Name">
                <a-input
                  placeholder="Institute name"
                  v-decorator="['name', {rules: [{ required: true, message: 'Please input institute name!' }]}]"
                />
                </a-form-item>
              </div>
              <div class="col-md-4">
                <a-form-item
                  label="Select Board"
                >
                  <a-select
                    v-decorator="[
                      'board_id',
                      {rules: [{ required: true, message: 'Please select a board!!' }]}
                    ]"
                    placeholder="Select board"
                  >
                    <a-select-option v-for="board in boards" :value="board.id" :key="board.id">
                    {{board.name}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="col-md-4">
                <a-form-item
                  label="Institute type"
                >
                  <a-select
                    v-decorator="[
                      'type',
                      {rules: [{ required: true, message: 'Please select an institute type!!' }]},
                    ]"
                    placeholder="Institute type"
                  >
                    <a-select-option v-for="institutetype in instituteTypes" :value="institutetype.value" :key="institutetype.value">
                    {{institutetype.name}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="col-md-4">
                <a-form-item
                  label="Owner type"
                >
                  <a-select
                    v-decorator="[
                      'owner_type',
                      {rules: [{ required: true, message: 'Please select an owner type!!' }]}
                    ]"
                    placeholder="Owner type"
                  >
                    <a-select-option v-for="ownertype in ownerTypes" :value="ownertype.value" :key="ownertype.value">
                    {{ownertype.name}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <div class="col-md-4">
                <a-form-item label="Registration No">
                <a-input
                  placeholder="Registration No"
                  v-decorator="['registration_no', {rules: [{ required: false, message: 'Please input Registration No!' }]}]"
                />
                </a-form-item>
              </div>
              <div class="col-md-4">
                <a-form-item label="Institute website">
                <a-input
                  placeholder="institute website"
                  v-decorator="['school_website', {rules: [{ required: false, message: 'Please input a valid url!', pattern: new RegExp(`^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$`) }]}]"
                />
                </a-form-item>
              </div>
              <div class="col-md-4">
                <a-form-item label="Subdomain">
                <a-input
                  placeholder="Subdomain"
                  v-decorator="['subdomain', {rules: [{ required: true, message: 'Please enter a valid subdomain!', pattern: new RegExp(`^[_A-z]*((-|\s)*[_A-z])*$`) }]}]"
                  :disabled="true"
                />
                </a-form-item>
              </div>
              <div class="col-md-4">
                <a-form-item
                  label="Established on"
                >
                <a-date-picker
                  v-decorator="[
                  'established_on',
                  {rules: [{ required: false, message: 'Please input establised date!' }],},
                  ]"
                  :disabled-date="disabledDate"
                  :format="dateFormat" />
                </a-form-item>
              </div>
            </div>

            <a-divider />
            <p class="pt-3">School Address</p>
            <div class="row">
              <div class="col-md-8">
                <a-form-item label="Address">
                  <a-input
                    placeholder="Street address"
                    v-decorator="['contact[address]', {rules: [{ required: true, message: 'Please input school address!' }]}]"
                  />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="City">
                <a-input
                  placeholder="City"
                  v-decorator="['contact[city]', {rules: [{ required: true, message: 'Please input city!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="District">
                <a-input
                  placeholder="District"
                  v-decorator="['contact[district]', {rules: [{ required: false, message: 'Please input a district!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Landmark">
                <a-input
                  placeholder="Landmark"
                  v-decorator="['contact[landmark]', {rules: [{ required: false, message: 'Please input a landmark!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Pincode">
                <a-input
                  placeholder="Pincode"
                  v-decorator="['contact[pincode]', {rules: [{ required: false, message: 'Please input a pincode!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="State">
                <a-input
                  placeholder="State"
                  v-decorator="['contact[state]', {rules: [{ required: true, message: 'Please input a state!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Country">
                <a-input
                  placeholder="Country"
                  v-decorator="['contact[country]', {rules: [{ required: true, message: 'Please input a country!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-4 d-none">
                <a-form-item label="Is Primary Contact?">
                  <a-checkbox v-decorator="['contact[is_primary]', {
                    valuePropName: 'checked',
                    initialValue: true,
                  }]">
                        Yes
                    </a-checkbox>
                </a-form-item>
              </div>
            </div>

            <a-divider />
            <p class="pt-3">School Contact</p>
            <div class="row">
              <div class="col-md-4">
                <a-form-item label="Phone">
                  <a-input
                    placeholder="Phone"
                    v-decorator="['contact[phone]', {rules: [{ required: true, message: 'Please input a valid phone!', pattern: new RegExp(`[1-9][0-9]{7,14}`) }]}]"
                    width="100%"
                  >
                  <a-select
                    slot="addonBefore"
                    v-decorator="[
                      'contact[country_code]',
                      { initialValue: '91' }
                    ]"
                    style="width: 70px"
                  >
                    <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                        <span class="text-bold">{{countryCode.name}}</span>
                    </a-select-option>
                  </a-select>
                  </a-input>
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Alt. Phone">
                  <a-input
                    placeholder="Alt. Phone"
                    v-decorator="['contact[alt_phone]', {rules: [{ required: false, message: 'Please input an valid alt phone!', pattern: new RegExp(`[1-9][0-9]{7,14}`) }]}]"
                    width="100%"
                  >
                    <a-select
                      slot="addonBefore"
                      v-decorator="[
                        'contact[alt_country_code]',
                        { initialValue: '91' }
                      ]"
                      style="width: 70px"
                    >
                      <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                        <span class="text-bold">{{countryCode.name}}</span>
                      </a-select-option>
                    </a-select>
                  </a-input>
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Email">
                  <a-input
                    placeholder="Email"
                    v-decorator="[
                      'contact[email]',
                      {
                        rules: [{
                          type: 'email', message: 'The input is not valid email!',
                        }, {
                          required: true, message: 'Please input an email!',
                        }]
                      }
                    ]"
                  />
                </a-form-item>
              </div>
            </div>

            <a-divider />
            <p class="pt-3">School GST Details</p>
            <div class="row">
              <div class="col-md-4">
                <a-form-item label="GST Number">
                <a-input
                  placeholder="GST Number"
                  v-decorator="['gst_no', {rules: [{ required: false, message: 'Please input school GST number!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="GST Name">
                <a-input
                  placeholder="GST Name"
                  v-decorator="['gst_name', {rules: [{ required: false, message: 'Please input a gst number!' }]}]"
                />
                </a-form-item>
              </div>

              <div class="col-md-8">
                <a-form-item label="GST Address">
                <a-input
                  placeholder="GST Address"
                  v-decorator="['gst_address', {rules: [{ required: false, message: 'Please input GST Address!' }]}]"
                />
                </a-form-item>
              </div>
            </div>

            <a-divider />
            <p class="pt-3">Currency Details</p>
            <div class="row">
              <div class="col-md-2 col-6">
                <a-form-item
                  label="Currency code"
                >
                  <a-select
                    v-decorator="[
                      'currency_code',
                      {rules: [{ required: true, message: 'Please select a currency code!!' }],  initialValue: 'INR' },
                    ]"
                  >
                    <a-select-option v-for="currencyCode in currencyCodes" :value="currencyCode.value" :key="currencyCode.value">
                    {{currencyCode.name}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>

              <div class="col-md-2 col-6">
                <a-form-item
                  label="Currency symbol"
                >
                  <a-select
                    v-decorator="[
                      'currency_symbol',
                      {rules: [{ required: true, message: 'Please select a currency symbol!!' }], initialValue: '₹'},
                    ]"
                  >
                    <a-select-option v-for="currencySymbol in currencySymbols" :value="currencySymbol.value" :key="currencySymbol.value">
                    <span class="text-bold">{{currencySymbol.name}}</span>
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </div>

            <a-divider />
            <p class="pt-3">Academic Settings</p>
            <div class="row">
              <div class="col-md-4 d-flex">
                <a-form-item label="Auto generate">
                  <a-checkbox v-decorator="['auto_student_id', {
                    valuePropName: 'checked',
                    initialValue: false,
                  }]">
                      Student ID
                  </a-checkbox>
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Id suffix">
                  <a-input
                    placeholder="NEO"
                    v-decorator="['id_suffix', {rules: [{ required: true, message: 'Please input an ID suffix' }, {max: 10, message: 'Should not be more than 10 characters'}]}]"
                  />
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Admission no. starts from">
                  <a-input-number
                    placeholder="1000"
                    v-decorator="['start_admission_no', {rules: [{ required: false, message: 'Please input admission no starts from!' }] }]"
                    :min="0"
                    :width="240"
                  />
                </a-form-item>
              </div>

              <!-- Staff Id -->
              <div class="col-md-4">
                <a-form-item label=" " :colon="false">
                  <a-checkbox v-decorator="['auto_staff_id', {
                    valuePropName: 'checked',
                    initialValue: true,
                  }]">
                      Staff ID
                  </a-checkbox>
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item label="Staff Id suffix">
                  <a-input
                    placeholder="NEO"
                    v-decorator="['staff_id_suffix', {rules: [{ required: true, message: 'Please input an ID suffix' }, {max: 10, message: 'Should not be more than 10 characters'}]}]"
                  />
                </a-form-item>
              </div>
              <div class="col-md-4">
                <a-form-item label="Staff Id no. starts from">
                  <a-input-number
                    placeholder="1000"
                    v-decorator="['start_staff_id_no', {rules: [{ required: false, message: 'Please input staff id no starts from!' }], initialValue: 0 }]"
                    :min="0"
                    :width="200"
                  />
                </a-form-item>
              </div>
            </div>
            <a-divider />
          <p class="pt-3">School Working Hours (Default )</p>
          <a-row :gutter="16">
             <a-col :span="12">
          <table>
            <tbody>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox v-decorator="['daily_working_hour[1][day]', { valuePropName: 'checked', initialValue: false }]" value="MONDAY">Monday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[1][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[1][end_time]']" use24-hours />
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-checkbox v-decorator="['weekly_working_hour[same_daily_timing]', { valuePropName: 'checked', initialValue: false }]" value="1" >Same for all</a-checkbox>
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox v-decorator="['daily_working_hour[2][day]', { valuePropName: 'checked', initialValue: false }]" default-value="TUESDAY">Tuesday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[2][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[2][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox v-decorator="['daily_working_hour[3][day]', { valuePropName: 'checked', initialValue: false }]" default-value="WEDNESDAY">Wednesday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[3][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[3][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox v-decorator="['daily_working_hour[4][day]', { valuePropName: 'checked', initialValue: false }]" default-value="THURSDAY">Thursday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[4][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[4][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox v-decorator="['daily_working_hour[5][day]', { valuePropName: 'checked', initialValue: false }]" default-value="FRIDAY">Friday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[5][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[5][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox v-decorator="['daily_working_hour[6][day]', { valuePropName: 'checked', initialValue: false }]" default-value="SATURDAY">Saturday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[6][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[6][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <a-form-item>
                    <a-checkbox v-decorator="['daily_working_hour[0][day]', { valuePropName: 'checked', initialValue: false }]" default-value="SUNDAY">Sunday</a-checkbox>
                  </a-form-item>
                </td>
                <td>
                  <a-form-item>
                    <a-time-picker v-decorator="['daily_working_hour[0][start_time]']" use24-hours />
                    -
                    <a-time-picker v-decorator="['daily_working_hour[0][end_time]']" use24-hours />
                  </a-form-item>
                </td>
              </tr>
            </tbody>
          </table>
          </a-col>
          <a-col :span="4">
    <div class="extra-count-box">
      <strong>Extra Count</strong>

      <a-form-item class="mt-2">
        <a-checkbox
          v-decorator="[
            'extra_count_enabled',
            { valuePropName: 'checked', initialValue: false }
          ]"
        >
          Enable
        </a-checkbox>
      </a-form-item>

      <a-form-item>
        <a-time-picker
          v-decorator="['extra_count_time']"
          format="HH:mm"
          use24-hours
          :disabled="!form.getFieldValue('extra_count_enabled')"
          style="width: 120px"
        />
      </a-form-item>
    </div>
  </a-col>
        </a-row>
          <a-divider />
<p class="pt-3">Seasonal Working Hours</p>

<a-alert
  type="info"
  show-icon
  message="Seasonal working hours override default hours for selected months."
  class="mb-3"
/>

<div
  v-for="(season, index) in seasonalHours"
  :key="index"
  class="season-row"
>
<a-row :gutter="12" align="middle" class="season-header mb-4" >

  <a-col :span="1">
    <a-checkbox v-model="season.enabled" />
  </a-col>

  <a-col :span="4">
    <a-input v-model="season.name" placeholder="Season name" />
  </a-col>

  <a-col :span="7">
    <a-select
      mode="multiple"
      v-model="season.months"
      placeholder="Select months"
    >
      <a-select-option v-for="m in months" :key="m.value" :value="m.value">
        {{ m.label }}
      </a-select-option>
    </a-select>
  </a-col>

  <a-col :span="3">
    <a-checkbox v-model="season.copyDefault" @change="handleCopyDefault(season)">
      Copy default
    </a-checkbox>
  </a-col>

  <a-col :span="2">
    <a-icon type="delete" style="color: #ff4d4f;" @click="removeSeason(index)" />
  </a-col>

</a-row>

<a-row class="season-container" type="flex" align="top">
  <a-col :span="1"></a-col>
  <a-col class="season-table-col">
<table class="season-days-table">
  <tr v-for="day in season.days" :key="day.day">
    <td width="120">
      <a-checkbox v-model="day.enabled">
        {{ day.day }}
      </a-checkbox>
    </td>

    <td>
      <a-time-picker
        v-model="day.start"
        use24-hours
        :disabled="!day.enabled"
      />
      -
      <a-time-picker
        v-model="day.end"
        use24-hours
        :disabled="!day.enabled"
      />
    </td>
  </tr>
</table>
</a-col>
<!-- RIGHT: Controls (same as default UX) -->
  <a-col class="season-controls-col">
    <a-checkbox
      v-model="season.sameForAll"
      @change="handleSameForAll(season)"
    >
      Same for all
    </a-checkbox>

    <a-checkbox
    v-model="season.enableAllDays"
    @change="handleEnableAllDays(season)"
  >
    Enable all days
  </a-checkbox>

  <a-tooltip
    placement="right"
    title="Disabling this will remove all day timings for this season when you save."
  >
    <a-icon
      type="info-circle"
      class="ml-2 text-warning"
    />
  </a-tooltip>
  </a-col>
</a-row>

</div>

<a-button
  type="primary"
  icon="plus"
  class="mt-3 mb-4"
  @click="addSeason"
>
  Add Seasonal Working Hours
</a-button>

            <a-divider />
            <p class="pt-3">Available facilities</p>
            <div class="row">
              <div class="col">
                <a-form-item>
                  <a-checkbox v-decorator="['hostel', {
                    valuePropName: 'checked',
                    initialValue: false,
                  }]"
                    :disabled="true"
                  >
                      Hostel
                  </a-checkbox>
                  <a-checkbox v-decorator="['transport', {
                    valuePropName: 'checked',
                    initialValue: false,
                  }]"
                    :disabled="true"
                  >
                      Transport
                  </a-checkbox>
                  <a-checkbox v-decorator="['library', {
                    valuePropName: 'checked',
                    initialValue: false,
                  }]"
                    :disabled="true"
                  >
                      Library
                  </a-checkbox>
                </a-form-item>
              </div>
            </div>

            <a-divider />
            <p class="pt-3">Theme Settings</p>
            <div class="row">
              <div class="col-md-4">
                <a-form-item
                  label="Font"
                >
                  <a-select
                    v-decorator="[
                      'font',
                      {rules: [{ required: true, message: 'Please select a font' }], initialValue: 'Source Sans Pro'},
                    ]"
                  >
                    <a-select-option v-for="themeFont in themeFonts" :value="themeFont.value" :key="themeFont.value">
                      <span class="text-bold" :style="`font-family:${themeFont.value}`">
                        {{themeFont.name}}
                      </span>
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>

              <div class="col-md-4">
                <a-form-item
                  label="Color"
                >
                  <a-select
                    v-decorator="[
                      'color',
                      {rules: [{ required: true, message: 'Please select a color' }], initialValue: '#1b55e3' },
                    ]"
                  >
                    <a-select-option v-for="themeColor in themeColors" :value="themeColor.value" :key="themeColor.value">
                      <span class="text-bold">
                        {{themeColor.name}}
                        <span :style="`background-color:${themeColor.value};`" class="neo-color-options"></span>
                      </span>
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </div>

            <a-divider />
            <p class="pt-3 mb-1">Upload Documents</p>
            <p class="font-italic text-warning">Logo should be JPG format and less than 2MB in size</p>
            <div class="row">
              <div class="col-6">
                <div class="row">
                  <div  v-if="logo && fileList.length === 0" class="col-md-3 col-6">
                    <div class="p-2 mb-3 bg-light">
                      <img :src="logo" alt="school logo" class="img-fluid" width="300">
                    </div>
                  </div>
                  <div class="col-md-4 col-6">
                    <a-form-item
                      label="Logo"
                    >
                      <a-upload
                        v-decorator="['logo', {rules: [{ required: false, message: 'Please select a logo' }]}]"
                        :fileList="fileList"
                        :multiple="false"
                        :remove="handleRemove"
                        :beforeUpload="beforeUpload"
                        :disabled="uploadDisabled"
                      >
                        <a-button v-if="!uploadDisabled">
                          <a-icon type="upload" /> Select File
                        </a-button>
                      </a-upload>
                    </a-form-item>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="row">
                  <div  v-if="logoAlt && fileListForAltLogo.length === 0" class="col-md-3 col-6">
                    <div class="p-2 mb-3 bg-light">
                      <img :src="logoAlt" alt="school logo alt" class="img-fluid" width="300">
                    </div>
                  </div>
                  <div class="col-md-4 col-6">
                    <a-form-item
                      label="Logo (Alternative)"
                    >
                      <a-upload
                        v-decorator="['logo_alt', {rules: [{ required: false, message: 'Please select an alternative logo' }]}]"
                        :fileList="fileListForAltLogo"
                        :multiple="false"
                        :remove="handleRemoveForLogoAlt"
                        :beforeUpload="beforeUploadForLogoAlt"
                        :disabled="uploadDisabledForLogoALt"
                      >
                        <a-button v-if="!uploadDisabledForLogoALt">
                          <a-icon type="upload" /> Select File
                        </a-button>
                      </a-upload>
                    </a-form-item>
                  </div>
                </div>
              </div>
            </div>

            <a-divider />
            <div class="row justify-content-between py-3">
              <div class="col-md-4"></div>
              <div class="col-md-4 text-md-right">
                <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Save</a-button>
              </div>
            </div>
          </a-form>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ant-drawer-close-x{
  margin-right: 0.7rem;
}
</style>

<script>
import { omit, mapValues } from 'lodash'
import { mapState } from 'vuex'
import { Row, Col } from 'ant-design-vue'
import moment from 'moment'
import { instituteTypes, ownerTypes, currencyCodes, currencySymbols, themeFonts, themeColors, paymentFrequencies } from '@/components/school/Forms/data'
import { countryCodes } from '@/services/globaldata'
import { excludeEditData, makeContactData, makeWorkingHourData } from '@/components/school/Forms/fields'

const dayname = [ 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY' ]

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function (value) {
    if (value === null || value === undefined) {
      return value
    }

    if (typeof value === 'boolean') {
      return value ? '1' : '0'
    }

    if (moment.isMoment(value)) {
      return moment(value).format('YYYY-MM-DD')
    }

    return value
  },

}
const DAY_INDEX_MAP = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
}

export default {
  components: {
    'a-row': Row,
    'a-col': Col,
  },
  mounted: function() {
    this.$http.get('/api/board')
      .then(({ data }) => {
        this.boards = data.data

        this.$http.get('/api/plan')
          .then(({ data }) => {
            this.plans = data.data
            this.getSchool()
          })
          .catch(error => {
            console.log(error)
          })
      })
      .catch(error => {
        console.log(error)
      })
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      schoolId: this.$store.state.user.user.school.id,
      loading: true,
      uploadDisabled: false,
      uploadDisabledForLogoALt: false,
      dateFormat: 'DD-MM-YYYY',
      boards: [],
      fileList: [],
      fileListForAltLogo: [],
      instituteTypes,
      ownerTypes,
      currencyCodes,
      currencySymbols,
      paymentFrequencies,
      themeFonts,
      themeColors,
      countryCodes,
      logo: null,
      logoAlt: null,
      seasonalHours: [
        {
          enabled: true,
          name: '',
          months: [],
          sameForAll: false,
          copyDefault: false,
          enableAllDays: false,
          days: [
            { day: 'MONDAY', enabled: true, start: null, end: null },
            { day: 'TUESDAY', enabled: true, start: null, end: null },
            { day: 'WEDNESDAY', enabled: true, start: null, end: null },
            { day: 'THURSDAY', enabled: true, start: null, end: null },
            { day: 'FRIDAY', enabled: true, start: null, end: null },
            { day: 'SATURDAY', enabled: false, start: null, end: null },
            { day: 'SUNDAY', enabled: false, start: null, end: null },
          ],
        },
      ],

      months: [
        { label: 'January', value: '01' },
        { label: 'February', value: '02' },
        { label: 'March', value: '03' },
        { label: 'April', value: '04' },
        { label: 'May', value: '05' },
        { label: 'June', value: '06' },
        { label: 'July', value: '07' },
        { label: 'August', value: '08' },
        { label: 'September', value: '09' },
        { label: 'October', value: '10' },
        { label: 'November', value: '11' },
        { label: 'December', value: '12' },
      ],
    }
  },
  computed: mapState(['settings']),
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days after today
      return current > moment().endOf('day')
    },
    getSchool() {
      this.loading = true
      this.spinning = true
      this.$http.get('/api/school/' + this.schoolId).then(({ data }) => {
        this.logo = data.data.logo || null
        this.logoAlt = data.data.logo_alt || null
        excludeEditData.push('status')
        const editData = omit(data.data, excludeEditData)
        editData.established_on = editData.established_on ? moment(editData.established_on, 'YYYY-MM-DD') : undefined
        if (data.data.extra_count_settings) {
          const extraSettings = data.data.extra_count_settings

          // Convert string "true"/"false" to boolean for checkbox
          if (extraSettings.extra_count_enabled !== undefined) {
            editData.extra_count_enabled = extraSettings.extra_count_enabled === 'true' ||
                                        extraSettings.extra_count_enabled === true ||
                                        extraSettings.extra_count_enabled === '1'
          }

          // Convert time string to moment object for time picker
          if (extraSettings.extra_count_time) {
            editData.extra_count_time = moment(extraSettings.extra_count_time, 'HH:mm')
          }
        } else {
          // Set defaults if no extra count settings exist
          editData.extra_count_enabled = false
          editData.extra_count_time = null
        }

        const contactData = makeContactData(data.data.contact)
        const timingProfiles = data.data.timing_profiles || []

        // 🔹 Default timing profile
        const defaultProfile = timingProfiles.find(p => p.is_default === 1)
        this.defaultTimingProfileId = defaultProfile ? defaultProfile.id : null
        console.log('Default Profile:', defaultProfile)

        // Seasonal timing profiles
        this.seasonalHours = timingProfiles
          .filter(p => p.is_default === 0)
          .map(p => {
            const daily = p.daily_working_hours || []

            // detect sameForAll from API data
            var sameForAll = false
            if (daily.length > 0) {
              var ref = daily[0]
              sameForAll = daily.every(function (d) {
                return (
                  d.start_time === ref.start_time &&
          d.end_time === ref.end_time
                )
              })
            }

            var copyDefault = false

            // Only auto-detect copyDefault for EXISTING seasons
            if (p.id && defaultProfile && daily.length > 0) {
              copyDefault = daily.every(function (d) {
                var def = defaultProfile.daily_working_hours.find(function (x) {
                  return x.day === d.day
                })

                if (!def) return false

                return (
                  d.start_time === def.start_time &&
      d.end_time === def.end_time
                )
              })
            }

            return {
              id: p.id,
              enabled: true,
              name: p.name,
              months: Array.isArray(p.months)
                ? p.months.map(m => String(m.month).padStart(2, '0'))
                : [],
              sameForAll: sameForAll,
              copyDefault: copyDefault,
              enableAllDays: false,
              days: dayname.map(d => {
                const found = daily.find(function (x) {
                  return x.day === d
                })

                return {
                  day: d,
                  enabled: !!found,
                  start: found ? moment(found.start_time, 'HH:mm:ss') : null,
                  end: found ? moment(found.end_time, 'HH:mm:ss') : null,
                }
              }),
              // Original days data for "Copy Default" functionality
              _originalDays: dayname.map(d => {
                const found = daily.find(x => x.day === d)
                return {
                  day: d,
                  enabled: !!found,
                  start: found ? moment(found.start_time, 'HH:mm:ss') : null,
                  end: found ? moment(found.end_time, 'HH:mm:ss') : null,
                }
              }),
            }
          })

        const dailyHours = defaultProfile && defaultProfile.daily_working_hours
          ? defaultProfile.daily_working_hours : []

        const prd = this.prepareReadableData(dailyHours)
        const workingHourData = makeWorkingHourData(
          prd,
          data.data.weekly_working_hour
        )

        const fieldsData = mapValues({ ...editData, ...contactData, ...workingHourData }, function(value) {
          return value !== null ? value : undefined
        })
        this.form.setFieldsValue({ ...fieldsData })
        this.spinning = false
        this.loading = false
      })
      this.visible = true
    },
    addSeason() {
      const days = [
        { day: 'SUNDAY', enabled: false, start: null, end: null },
        { day: 'MONDAY', enabled: false, start: null, end: null },
        { day: 'TUESDAY', enabled: false, start: null, end: null },
        { day: 'WEDNESDAY', enabled: false, start: null, end: null },
        { day: 'THURSDAY', enabled: false, start: null, end: null },
        { day: 'FRIDAY', enabled: false, start: null, end: null },
        { day: 'SATURDAY', enabled: false, start: null, end: null },
      ]

      this.seasonalHours.push({
        enabled: true,
        name: '',
        months: [],
        sameForAll: false,
        copyDefault: false,
        enableAllDays: false,
        days: days,
        _originalDays: days.map(d => ({
          day: d.day,
          enabled: d.enabled,
          start: null,
          end: null,
        })),
      })
    },

    removeSeason(index) {
      this.seasonalHours.splice(index, 1)
    },
    formatTime(time) {
      return time ? moment(time).format('HH:mm:ss') : null
    },

    handleCopyDefault(season) {
      if (!season.copyDefault) {
        season.days = season._originalDays.map(d => ({
          day: d.day,
          enabled: d.enabled,
          start: d.start ? moment(d.start) : null,
          end: d.end ? moment(d.end) : null,
        }))
        return
      }

      season.days.forEach(day => {
        const index = DAY_INDEX_MAP[day.day]

        const start = this.form.getFieldValue(`daily_working_hour[${index}][start_time]`)
        const end = this.form.getFieldValue(`daily_working_hour[${index}][end_time]`)
        const isEnabled = this.form.getFieldValue(`daily_working_hour[${index}][day]`)

        if (isEnabled && start && end) {
          day.start = moment(start)
          day.end = moment(end)
          day.enabled = true
        } else {
          day.start = null
          day.end = null
          day.enabled = false
        }
      })
    },

    handleSameForAll(season) {
      if (!season.sameForAll) {
        return
      }

      var monday = season.days.find(function (d) {
        return d.day === 'MONDAY'
      })

      if (!monday || !monday.start || !monday.end) {
        this.$message.warning('Please set Monday timing first')
        season.sameForAll = false
        return
      }

      season.days.forEach(function (d) {
        if (d.enabled) {
          // clone moment, do not reference
          d.start = moment(monday.start)
          d.end = moment(monday.end)
        }
      })
    },

    handleEnableAllDays(season) {
      if (season.enableAllDays) {
        season.days.forEach(day => {
          day.enabled = true
        })
      } else {
        // ONLY disable — do NOT wipe data
        season.days.forEach(day => {
          day.enabled = false
        })
      }
    },

    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    handleRemoveForLogoAlt(file) {
      const index = this.fileListForAltLogo.indexOf(file)
      const newFileList = this.fileListForAltLogo.slice()
      newFileList.splice(index, 1)
      this.fileListForAltLogo = newFileList
      this.uploadDisabledForLogoALt = false
    },
    beforeUpload (file) {
      const isValidated = this.commonValidation(file)
      if (!isValidated) {
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },
    beforeUploadForLogoAlt (file) {
      const isValidated = this.commonValidation(file)
      if (!isValidated) {
        return false
      }
      this.fileListForAltLogo = [...this.fileListForAltLogo, file]
      // return isJPG && isLt2M
      this.uploadDisabledForLogoALt = true
      return false
    },
    commonValidation (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJPG) {
        this.$message.error('You can only upload JPG file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!')
        return false
      }
      return true
    },
    prepareReadableData: function(data = []) {
      const processServerData = (data) => {
        return dayname.map((e) => {
          const dailydata = data.find(item => item.day === e)

          if (!dailydata) {
            return {
              day: false,
              start_time: undefined,
              end_time: undefined,
              dayname: e,
            }
          }

          return {
            day: true,
            start_time: dailydata.start_time,
            end_time: dailydata.end_time,
            dayname: dailydata.day,
          }
        })
      }

      return processServerData(Array.isArray(data) ? data : [])
    },
    buildDefaultTimingProfile(values) {
      var daily = []
      var sameForAll =
    values.weekly_working_hour &&
    values.weekly_working_hour.same_daily_timing

      // Monday = index 1
      var monday = values.daily_working_hour[1]
      var mondayStart = monday ? monday.start_time : null
      var mondayEnd = monday ? monday.end_time : null

      values.daily_working_hour.forEach(function (d, index) {
        if (d && d.day) {
          daily.push({
            day: dayname[index],
            start_time: this.formatTime(
              sameForAll ? mondayStart : d.start_time
            ),
            end_time: this.formatTime(
              sameForAll ? mondayEnd : d.end_time
            ),
            break_start: null,
            break_end: null,
          })
        }
      }, this)

      return {
        id: this.defaultTimingProfileId || null,
        name: 'Default Timing',
        is_default: true,
        months: [],
        daily_working_hours: daily,
      }
    },

    buildSeasonalTimingProfiles() {
      return this.seasonalHours
        .filter(season => season.enabled)
        .map(season => {
          const daily = season.days
            .filter(d => d.enabled && d.start && d.end)
            .map(d => ({
              day: d.day,
              start_time: this.formatTime(d.start),
              end_time: this.formatTime(d.end),
              break_start: null,
              break_end: null,
            }))

          return {
            id: season.id ? Number(season.id) : undefined,
            name: season.name,
            is_default: false,
            months: season.months.map(m => parseInt(m, 10)),
            daily_working_hours: daily,
          }
        })
    },

    processUIData: function(_data, _weekdata) {
      // console.log('processFalseInputData', { daily: _data, weekly: _weekdata })
      let readyDailyData = [{ day: undefined, start_time: undefined, end_time: undefined }]
      let readyWeeklyData = { working_days: undefined, working_hours: undefined, same_daily_timing: undefined, start_time: undefined, end_time: undefined }

      if (_data === null || _data === undefined || _weekdata === null || _weekdata === undefined) {
        console.error('Code 5040 - An error occured getting UI data.')
      } else {
        let samehour = _weekdata.same_daily_timing
        let { starttime, endtime } = { ...{ starttime: _data[1].start_time, endtime: _data[1].end_time } }
        if (samehour === null || samehour === undefined) {
          console.error('Code 5040 - An error occured getting UI data.')
          samehour = 0
        } else {
          samehour = samehour ? 1 : 0
        }
        if (_data.length === 0) {
          console.error('Code 5041 - tempered/empty UI array')
        } else {
          let daycount = 0
          let weekhour = 0
          readyDailyData = _data.map(function (e, index) {
            if (e.day === false) {
              return { day: undefined, start_time: undefined, end_time: undefined }
            } else {
              daycount++
              weekhour += moment.duration(moment(e.end_time).diff((moment(e.start_time)))).asHours()
              return { day: dayname[index], start_time: samehour === 1 ? moment(starttime).format('HH:mm:ss') : moment(e.start_time).format('HH:mm:ss'), end_time: samehour === 1 ? moment(endtime).format('HH:mm:ss') : moment(e.end_time).format('HH:mm:ss') }
            }
          })
          // time calculation
          if (samehour === 1) weekhour = daycount * moment.duration(moment(endtime).diff((moment(starttime)))).asHours()
          // end time calculation
          readyWeeklyData = { working_days: daycount, working_hours: weekhour, same_daily_timing: samehour, start_time: moment(starttime).format('HH:mm:ss'), end_time: moment(endtime).format('HH:mm:ss') }
        }
      }
      // console.log('daily readydata', readyDailyData)
      // console.log('weekly readydata', readyWeeklyData)
      return { daily: readyDailyData, weekly: readyWeeklyData }
    },
    handleSubmit(e) {
      this.loading = true

      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update school: ${values.name}?`,
            content: `Click on the OK button to update the school!`,
            onOk: () => {
              const timingProfiles = []

              // 🔹 clone first (DO NOT mutate original values)
              const valuesCopy = { ...values }

              // Default timing
              timingProfiles.push(this.buildDefaultTimingProfile(valuesCopy))

              // Seasonal timings
              timingProfiles.push(...this.buildSeasonalTimingProfiles())

              values.timing_profiles = timingProfiles

              // Remove legacy field AFTER usage
              delete values.daily_working_hour

              if (values.extra_count_time) {
                values.extra_count_time =
    moment(values.extra_count_time).format('HH:mm')
              }

              if (!values.alt_phone) {
                values.alt_country_code = undefined
              }

              let logoFile = null
              if (values.logo) {
                logoFile = values.logo.file
                values.logo = undefined
              }
              let logoAltFile = null
              if (values.logo_alt) {
                logoAltFile = values.logo_alt.file
                values.logo_alt = undefined
              }

              let formData = window.jsonToFormData(values, options)
              formData.set(
                'extra_count_enabled',
                values.extra_count_enabled === true
              )

              if (logoFile) {
                formData.append('logo', logoFile)
              }
              if (logoAltFile) {
                formData.append('logo_alt', logoAltFile)
              }

              formData.append('_method', 'PATCH')

              this.$http
                .post('/api/school/' + this.schoolId, formData)
                .then(({ data }) => {
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'School details successfully updated!',
                    description: `${data.data.name} updated successfully!`,
                  })
                  this.fileList = []
                  this.fileListForAltLogo = []
                  this.logo = null
                  this.logoAlt = null
                  this.uploadDisabled = false
                  this.uploadDisabledForLogoALt = false
                  this.getSchool()
                  this.$theme.set(document)
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss">
.neo-color-options{
  width:20px;
  height:20px;
  float:right;
}
.ant-select-selection-selected-value{
  .neo-color-options{
    margin-left: 1rem;
    margin-top: 0.3rem;
  }
}
.season-controls {
  display: flex;
  justify-content: flex-start;
}

.controls-box {
  margin-top: 32px; /* aligns with first row */
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.season-row {
  padding: 16px 0;
}

.season-row + .season-row {
  margin-top: 24px;
  border-top: 1px dashed #e8e8e8;
}

</style>
